import AssignmentsHelpMdx from "../../help/assignments.mdx";

export function AssignmentsHelpPage() {
  return <AssignmentsHelpMdx />;
}
